import React, { useState } from "react";

import TopicCategoryContext from "../../../contexts/TopicCategoryContext";

import PageTitleNew from "../../ui/PageTitleNew";
import Table from "./Table";
import ModalForm from "./Form/Modal";

export default function Index() {
  return (
    <TopicCategoryContext>
      <div className="wrapper_assestment invite_wrapper">
        <PageTitleNew title="Topic Categories" />

        <div className="ibox-content mt20">
          <Table />
        </div>
      </div>
      <ModalForm />
    </TopicCategoryContext>
  );
}
